import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { getStringByTextKey } from '@/utils/getStringByTextKey'

import './style.scss'

@inject('store')
@observer
export default class StepBarComponent extends Component {
  render() {
    const { step } = this.props

    return (
      <div className="stepBar">
        <div className={`box ${step === 1 ? 'box-active' : 'box-inactive'}`}>
          {step === 1 && <i className="step_number step_number-active">1</i>}
          {(step === 2 || step === 3) && (
            <i className="step_number step_number-done"></i>
          )}
          <span>{getStringByTextKey('logIn.stepBar.step1')}</span>
        </div>
        <div className={`box ${step === 2 ? 'box-active' : 'box-inactive'}`}>
          {step === 1 && <i className="step_number step_number-inactive">2</i>}
          {step === 2 && <i className="step_number step_number-active">2</i>}
          {step === 3 && <i className="step_number step_number-done"> </i>}
          <span>{getStringByTextKey('logIn.stepBar.step2')}</span>
        </div>
        <div className={`box ${step === 3 ? 'box-active' : 'box-inactive'}`}>
          {(step === 1 || step === 2) && (
            <i className="step_number step_number-inactive">3</i>
          )}
          {step === 3 && <i className="step_number step_number-active">3</i>}
          <span>{getStringByTextKey('logIn.stepBar.step3')}</span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Console/StepBar/index.js